// ABOUTME: Typed client wrapper for the Admin Panel account management API (super_admin only).
import { AdminRole } from '../../../types/adminRoles';
import axios from 'axios';

const API_URL = '/v2/api/admin/accounts';

export interface Account {
  id: string;
  email: string;
  name: string;
  role: AdminRole;
  createdAt?: string;
}

export interface CreateAccountInput {
  email: string;
  name: string;
  role: AdminRole;
  password: string;
}

export const accountsApi = {
  getAll: async (): Promise<{ accounts: Account[] }> => {
    const response = await axios.get(API_URL);
    return response.data;
  },

  create: async (data: CreateAccountInput): Promise<Account> => {
    const response = await axios.post(API_URL, data);
    return response.data;
  },

  updateRole: async (id: string, role: AdminRole): Promise<Account> => {
    const response = await axios.patch(`${API_URL}/${id}`, { role });
    return response.data;
  },

  remove: async (id: string): Promise<void> => {
    await axios.delete(`${API_URL}/${id}`);
  },
};
